export function validateEditRecurringChargeForm(editRecurringChargeForm){
  const { payment_source, starts_at, ends_at, interval_count, interval, 
          end_type, occurrences, has_credit_card_to_charge, invoice_client, 
          email, amount, due_days_after_invoice, name } = editRecurringChargeForm

  const validate_recurring_schedule = () => (
    !!starts_at &&
    !!interval_count &&
    !!interval &&
    ( 
      !end_type ||
      end_type == 'never' ||
      (end_type == 'on_date' && !!ends_at) ||
      (end_type == 'number_of_occurrences' && !!occurrences)
    )
  )

  const validate_credit_card_to_charge = () => (
    has_credit_card_to_charge == 'no' || (
      has_credit_card_to_charge == 'yes' &&
      !!payment_source 
    )
  )

  const validate_invoicing = () => (
    has_credit_card_to_charge == 'yes' || (
      has_credit_card_to_charge == 'no' && 
      invoice_client == 'no' || (
        invoice_client == 'yes' &&
        !!email
      )
    )
  )

  
  return (
    amount > 0 &&
    !!name &&
    validate_recurring_schedule() &&
    validate_credit_card_to_charge() &&
    validate_invoicing()
  )
}